export const LIVE_AUDIO_ENCODING = 'pcm16';
export const LIVE_AUDIO_SAMPLE_RATE = 16000;

/**
 * Downsample browser microphone samples and encode signed 16-bit little-endian
 * PCM as base64. Every packet is independently decodable, unlike later WebM
 * MediaRecorder fragments which depend on the first fragment's header.
 */
export function encodePcm16Chunk(input, inputSampleRate, outputSampleRate = LIVE_AUDIO_SAMPLE_RATE) {
  if (!(input instanceof Float32Array) || input.length === 0) return '';
  const sourceRate = Number(inputSampleRate);
  const targetRate = Number(outputSampleRate);
  if (!Number.isFinite(sourceRate) || !Number.isFinite(targetRate) || sourceRate <= 0 || targetRate <= 0) return '';

  const ratio = Math.max(1, sourceRate / targetRate);
  const sampleCount = Math.max(1, Math.floor(input.length / ratio));
  const pcm = new Int16Array(sampleCount);
  for (let i = 0; i < sampleCount; i += 1) {
    const from = Math.floor(i * ratio);
    const to = Math.min(input.length, Math.max(from + 1, Math.floor((i + 1) * ratio)));
    let sum = 0;
    for (let j = from; j < to; j += 1) sum += input[j];
    const sample = Math.max(-1, Math.min(1, sum / (to - from)));
    pcm[i] = sample < 0 ? Math.round(sample * 0x8000) : Math.round(sample * 0x7fff);
  }

  const bytes = new Uint8Array(pcm.buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

/** Decode one independent PCM packet for Web Audio playback. */
export function decodePcm16Chunk(base64) {
  const binary = atob(base64);
  const byteLength = binary.length - (binary.length % 2);
  const bytes = new Uint8Array(byteLength);
  for (let i = 0; i < byteLength; i += 1) bytes[i] = binary.charCodeAt(i);
  const view = new DataView(bytes.buffer);
  const samples = new Float32Array(byteLength / 2);
  for (let i = 0; i < samples.length; i += 1) {
    samples[i] = view.getInt16(i * 2, true) / 0x8000;
  }
  return samples;
}
